import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { useParams } from 'react-router-dom';
import { FinanceBlock } from '../../components/generaldata/generaldatapages/finance'; 

const FinancePage: FC = () => {
    const { alias } = useParams<{alias: string}>();
    const {t} = useTranslation();

    if (!alias) {
        return <div> alias не найден </div>
    }

    return (
        <>
            <Helmet>
                <title>Финансы</title>
            </Helmet>
            <FinanceBlock alias={String(alias)}/>
        </>
    );
};

export default FinancePage
